import React, { useState } from 'react';
import { Form, Container, Row, Col, Button, Tab } from 'react-bootstrap';
import CheckRow from './CheckRow';
import CheckCol from './CheckCol';

function FormularioJSON({ dados, onChecked, selecoes }) {
  // const [selecoes, setSelecoes] = useState({});

  const handleCheckboxChange = (item, isChecked, itemSelect) => {
    // setSelecoes((prevSelecoes) => ({
    //   ...prevSelecoes,
    //   [itemSelect]: isChecked,
    // }));

    onChecked(item, isChecked, itemSelect);
  };

  return (
    <Container>
      <CheckCol dados={dados} onChecked={handleCheckboxChange} selecoes={selecoes} />
    </Container>
  );
}

export default FormularioJSON;